export default "__VITE_ASSET__CXkyvPCf__"